<template>
    <div>
        <div :class="xgId" :style="{width:width+'px',height:height+'px'}"></div>
    </div>
</template>
<script>
// 全部引入
import DPlayer from 'dplayer'
// // 轻量级引入 只引入播放内核相关 其他自行引入
// // 播放内核
// import Player from 'xgplayer/dist/core_player';
// // 暂停/播放
// import play from 'xgplayer/dist/controls/play';
// // 全屏
// import fullscreen from 'xgplayer/dist/controls/fullscreen';
// // 进度条
// import progress from 'xgplayer/dist/controls/progress';
// // 音量
// import volume from 'xgplayer/dist/controls/volume';
// // 画中画
// import pip from 'xgplayer/dist/controls/pip';
// import flex from 'xgplayer/dist/controls/flex';
export default {
    name:'DPlayer',
    props:{
        xgId:{
            type:String,
            default:'xgId'
        },
        height:{
            type:Number,
            default:337.5
        },
        width:{
            type:Number,
            default:600
        },
        vadioUrl:{
            type:String,
            default:''
        },
    },
    data(){
        return {
            playered:null
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(()=>{
            this.init()
        })
    },
    methods:{
        init(){
            console.log(this.vadioUrl)
            this.playered = new DPlayer({
                container:document.getElementsByClassName(this.xgId)[0],
                lang:'zh-cn',
                playbackSpeed: [0.5, 0.75, 1, 1.5, 2],
                video: {
                    url: this.vadioUrl,
                    type: 'auto',
                },
            })
        }
    }
}
</script>  